<main class="main-home-secton">
  <div class="bg">
    <div class="container">
      <div class="about">
        <div class="row">
          <div class="col-lg-12">
            <div class="CSR_banner text-center">
              <div class="title">
                <h1 class="mb-2 mt-2">Pre- Incubation Centre</h1>
                <p>
                  StartupTN invites application from eligible educational
                  institutions for the establishment of Pre-Incubation Centres
                </p>
                <!-- <h6>Apply before 31<sup>st</sup> March 2026, 12.00 AM</h6> -->
              </div>

              <div class="btn-margin">
                <!-- <button class="Partner-btn" (click)="preincubtorregister()" [disabled]="isRegistrationClosedPre">
                  {{
                  isRegistrationClosedPre
                  ? "Registration Closed"
                  : "Apply Now For PIC"
                  }}
                </button> -->
                <button class="Partner-btn" (click)="preincubtorregister()">
                  Apply Now For PIC
                </button>
                <button class="corprate-btn" (click)="pdfDownload()">
                  Download Scheme Document
                </button>
                <button class="corprate-btn" style="margin-left: 15px;"(click)="pdfDownloadPIC()">
                    Pre-Incubation Centres List
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pre- incubation Center -->
  <div class="container">
    <div class="Pre-incubation-Center">
      <div class="pre-title">
        <h4>Pre- incubation Centre</h4>
        <div class="pre-title-img">
          <img src="/assets/images/title-line.png" alt="" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7">
          <div class="pre-incubation-center-para">
            <p class="mb-5">
              StartupTN Pre Incubation Centres (PIC) is visioned to support
              early-stage startups and scalable innovations in Idea Validation,
              Mentorship, Training and Workshops, Networking Opportunities till
              Proof-of-Concept Support.
            </p>
            <p>
              Institutions that are interested to help aspiring entrepreneurs in
              Prototype Development, guidance and mentor startups with the
              support of experienced entrepreneurs, conduct workshops, seminars
              and training sessions on various aspects of entrepreneurship can
              set up a StartupTN Pre Incubation Centre. StartupTN has proposed
              to establish 100 Pre-Incubation centres in Tier II, III and IV
              Cities of Tamil Nadu over a period of four years where a formal
              Incubation Centre is yet to be created.
            </p>
          </div>
        </div>
        <div class="col-lg-5 img-res">
          <img src="/assets/images/blub.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>

  <!-- Evaluation Process -->

  <div class="Evaluation">
    <div class="container-fluid">
      <div class="Evaluation-title">
        <h2>StartupTN Pre Incubation Centre Evaluation Process</h2>
      </div>
      <div class="extra-margin">
        <div class="initive-card-container">
          <div class="initive-card">
            <div class="initive-card-number">1</div>
            <img class="asscard-img" src="/assets/images/Evaluation-1.png" alt="" />
            <p class="initive-card-cont">Submission Of EOI</p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">2</div>
            <img class="asscard-img" src="/assets/images/Evaluation-2.png" alt="" />
            <p class="initive-card-cont">Internal Screeing</p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">3</div>
            <img class="asscard-img" src="/assets/images/Evaluation-3.png" alt="" />
            <p class="initive-card-cont">
              Presentation to Management Committee
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">4</div>
            <img class="asscard-img" src="/assets/images/Evaluation-4.png" alt="" />
            <p class="initive-card-cont">Shortlisted Proposals Announcement</p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">5</div>
            <img class="asscard-img" src="/assets/images/Evaluation-5.png" alt="" />
            <p class="initive-card-cont">
              Facility visit & Formation of Legal entity For PIC
            </p>
          </div>
        </div>
        <div class="initive-card-container Evaluation-changes">
          <div class="initive-card">
            <div class="initive-card-number">6</div>
            <img class="asscard-img" src="/assets/images/Evaluation-6.png" alt="" />
            <p class="initive-card-cont">
              Signing of MOU for Pre Incubation Centre
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">7</div>
            <img class="asscard-img" src="/assets/images/Evaluation-7.png" alt="" />
            <p class="initive-card-cont">Sanction order</p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">8</div>
            <img class="asscard-img" src="/assets/images/Evaluation-8.png" alt="" />
            <p class="initive-card-cont">
              Administartive approval and release of Funds
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">9</div>
            <img class="asscard-img" src="/assets/images/Evaluation-9.png" alt="" />
            <p class="initive-card-cont">Implementation</p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">10</div>
            <img class="asscard-img" src="/assets/images/Evaluation-10.png" alt="" />
            <p class="initive-card-cont">Quarterly review of PIC</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Evaluation-time -->
  <div class="container">
    <div class="evaluation-times">
      <div class="Evaluation-time">
        <!-- <h3>Apply before 31<sup>st</sup> March 2026, 12:00 AM</h3> -->
        <h3>Apply Now For PIC</h3>
      </div>
      <div class="evaluation-btn">
        <!-- <button class="Partner-btns" (click)="preincubtorregister()" [disabled]="isRegistrationClosedPre">
          {{ isRegistrationClosedPre ? "Registration Closed" : "Apply Now" }}
        </button> -->
        <button class="Partner-btns" (click)="preincubtorregister()">
          Apply Now
        </button>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>